import { useState } from "react";

export enum EditTournamentTab {
  BASE = "BASE",
  PRIZE = "PRIZE",
  PARTICIPATION = "PARTICIPATION",
  STRUCTURE = "STRUCTURE",
  LIVE = "LIVE",
  RESERVATION = "RESERVATION",
}

export const useTournamentTab = () => {
  const [tournamentTab, setTournamentTab] = useState(EditTournamentTab.BASE);

  const isTournamentTab = (tab: EditTournamentTab) => tournamentTab === tab;

  return { tournamentTab, setTournamentTab, isTournamentTab };
};
